import jqRequest from '../jqRequest'
import loginUrls from '../urls/login'

export default {
  // 获取手机验证码
  getAuthCode(data) {
    return jqRequest.requestWithToken(loginUrls.getAuthCode, data);
  },
  // 手机验证码登录，获取用户信息
  getMemberByToken(data) {
    return jqRequest.requestWithToken(loginUrls.getMemberByToken, data);
  },
  // 微信授权登录后获取登录信息
  getWeixinMemberInfo(data){
    return jqRequest.requestWithToken(loginUrls.getWeixinMemberInfo, data);
  }
}